import Dropdown from "../utils/classes/Dropdown";
import { debounce } from "../utils/performance";
import { getSearchInputElements, handleSearchInput, handleSearchReset } from "../utils/searchInput";
import { getQueryParams, getQueryParamsValues, updateQueryParamsByFilters } from "../utils/queryParams";

export default function(el) {
    const [searchWrapper, searchInput, searchReset] = getSearchInputElements(el);
    const noJobsEl = el.querySelector(".jo__no-jobs");
    const moreJobsEl = el.querySelector(".jo__more-jobs");
    const jobsPerPage =
        el.dataset.jobsPerPage && parseInt(el.dataset.jobsPerPage, 10)
            ? parseInt(el.dataset.jobsPerPage, 10)
            : null;
    const pagingEnabled = moreJobsEl && jobsPerPage ? true : false;
    const queryParams = getQueryParams();
    const dropdownEls = el.querySelectorAll(".dropdown");
    const dropdowns = {};

    const state = {
        jobs: [],
        filteredJobs: [],
        filters: [],
        jobsShown: jobsPerPage,
    };

    const createJobsDataStructure = () => {
        const jobElements = el.querySelectorAll(".jo__job-item");
        const data = [];

        if (jobElements.length === 0) return;

        jobElements.forEach((element) => {
            const titleEl = element.querySelector(".jo__job-title");
            const countryEl = element.querySelector(".jo__job-country");
            const teamEl = element.querySelector(".jo__job-team");

            data.push({
                element,
                title: titleEl ? titleEl.innerText : null,
                location: countryEl ? countryEl.innerText : null,
                team: teamEl ? teamEl.innerText : null,
            });
        });

        return data;
    };

    const handleInput = debounce((e) => {
        state.filters["search"] = {
            value: e.target.value,
            handler: searchFilterHandler,
        };

        filterJobs();
    }, 300);

    const searchFilterHandler = (jobs, value, filterName) =>
        jobs.filter((job) =>
            value
                .toLowerCase()
                .split(" ")
                .every((searchTerm) => job.title.toLowerCase().includes(searchTerm))
        );

    const handleDropdownValueChange = (clickedElement, dropdown) => {
        const filterName = dropdown.el.dataset.filterName;

        if (!filterName) return;

        state.filters[filterName] = {
            value: dropdown.currentValue !== dropdown.defaultValue ? dropdown.currentValue : null,
            handler: dropdownFilterHandler,
        };

        filterJobs();
    };

    const dropdownFilterHandler = (jobs, value, filterName) =>
        jobs.filter((job) => job[filterName] && job[filterName] === value);

    const filterJobs = () => {
        state.filteredJobs = state.jobs;
        state.jobsShown = 0;

        for (const [filterName, filterObj] of Object.entries(state.filters)) {
            if (!filterObj.value || !filterObj.handler || typeof filterObj.handler !== "function") continue;

            state.filteredJobs = filterObj.handler(state.filteredJobs, filterObj.value, filterName);
        }

        for (const job of state.jobs) {
            if (job.element.classList.contains("jo__job-item--first"))
                job.element.classList.remove("jo__job-item--first");

            job.element.classList.add("jo__job-item--hidden");
        }

        for (const [index, job] of state.filteredJobs.entries()) {
            if (pagingEnabled && index >= jobsPerPage) break;

            if (index === 0) job.element.classList.add("jo__job-item--first");

            job.element.classList.remove("jo__job-item--hidden");
            state.jobsShown = index + 1;
        }

        noJobsEl &&
            noJobsEl.classList[state.filteredJobs.length === 0 ? "add" : "remove"]("jo__no-jobs--active");

        if (pagingEnabled)
            moreJobsEl.classList[state.filteredJobs.length > jobsPerPage ? "remove" : "add"](
                "jo__more-jobs--hidden"
            );

        updateQueryParamsByFilters(queryParams, state.filters);
    };

    const handleDefaultState = () => {
        const queryValues = getQueryParamsValues(queryParams);

        for (const [queryKey, queryValue] of Object.entries(queryValues)) {
            if (queryKey === "search") {
                searchInput.value = queryValue;
                handleInput({ target: { value: queryValue } });
                handleSearchInput(searchWrapper, "search-input--filled", { target: { value: queryValue } });
                continue;
            }

            if (dropdowns[queryKey]) dropdowns[queryKey].setValue(queryValue);
        }
    };

    const handleMoreJobsClick = () => {
        if (state.jobsShown >= state.filteredJobs.length) return;

        const boundary = state.jobsShown + jobsPerPage;

        for (let i = state.jobsShown; i < boundary; i++) {
            if (!state.filteredJobs[i]) break;

            state.filteredJobs[i].element.classList.remove("jo__job-item--hidden");
            state.jobsShown = i + 1;
        }

        if (state.jobsShown >= state.filteredJobs.length) moreJobsEl.classList.add("jo__more-jobs--hidden");
    };

    state.jobs = state.filteredJobs = createJobsDataStructure();

    if (searchInput) searchInput.addEventListener("input", handleInput);

    if (searchReset) {
        if (searchWrapper)
            searchInput.addEventListener(
                "input",
                handleSearchInput.bind(null, searchWrapper, "search-input--filled")
            );

        searchReset.addEventListener("click", handleSearchReset.bind(null, searchInput));
    }

    if (dropdownEls.length !== 0)
        dropdownEls.forEach((dropdownEl) => {
            const filterName = dropdownEl.dataset.filterName;

            if (!filterName) return;

            const dropdown = new Dropdown(dropdownEl);
            dropdown.run();
            dropdown.on("valueChange", handleDropdownValueChange);
            dropdowns[filterName] = dropdown;
        });

    if (pagingEnabled) moreJobsEl.addEventListener("click", handleMoreJobsClick);

    handleDefaultState();
}
